const AVATAR_PROXY_ENDPOINT = "/tg-avatar"

function isTelegramAvatarHost(hostname: string): boolean {
  const host = hostname.toLowerCase()
  return host === "t.me" || /^cdn\d+\.telesco\.pe$/i.test(host)
}

function isPinterestAvatarHost(hostname: string): boolean {
  const host = hostname.toLowerCase()
  return host === "i.pinimg.com" || host.endsWith(".pinimg.com")
}

export function shouldProxyAvatarUrl(rawUrl: string): boolean {
  try {
    const parsed = new URL(rawUrl)
    if (parsed.protocol !== "https:") return false
    return (
      isTelegramAvatarHost(parsed.hostname) ||
      isPinterestAvatarHost(parsed.hostname)
    )
  } catch {
    return false
  }
}

export function toAvatarProxyUrl(rawUrl: string): string {
  const proxyUrl = new URL(AVATAR_PROXY_ENDPOINT, window.location.origin)
  proxyUrl.searchParams.set("u", rawUrl)
  const v = getProxyCacheVersionToken()
  if (v) proxyUrl.searchParams.set("v", v)
  return proxyUrl.toString()
}

export function resolveAvatarLoadUrl(rawUrl: string): string {
  if (shouldProxyAvatarUrl(rawUrl)) {
    return toAvatarProxyUrl(rawUrl)
  }
  return rawUrl
}

function getProxyCacheVersionToken(): string | null {
  if (typeof window === "undefined") return null
  const host = window.location.hostname || ""
  if (!host) return null
  const normalized = host.replace(/[^A-Za-z0-9_-]/g, "_")
  if (!normalized) return null
  return normalized.slice(0, 64)
}
